import {Checkbox, Form, Input, InputNumber, Radio, Spin} from 'antd'
import {DealBean, DealDspSeatBean} from 'common/api/api'
import {AnchorsForm} from 'common/components/AnchorsForm.tsx'
import {ButtonsPanel} from 'common/components/ButtonsPanel.tsx'
import {DeviceTypeSelector} from 'common/components/dictionary/DeviceTypeSelector.tsx'
import {FormatTypeSelector} from 'common/components/dictionary/FormatTypeSelector.tsx'
import {FormCard} from 'common/components/FormCard.tsx'
import {DomainSelector} from 'common/components/reloadable/DomainSelector.tsx'
import {PublisherSelector} from 'common/components/reloadable/PublisherSelector.tsx'
import {useAppContext} from 'common/context/AppContext.tsx'
import {CommonRoutes} from 'common/context/commonRoutes'
import { queueListRepositionOnModifiedChange } from 'common/util/listNavigation.ts';
import {apiCall, FormMode} from 'common/util/Util.tsx'
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import AuctionTypeEnum = DealBean.AuctionTypeEnum
import {dealApi} from 'common/api/entitiesApi.tsx'

const FormItem = Form.Item
const RadioGroup = Radio.Group


interface DealFormProps {
    mode: 'create' | 'edit'
}

const DealForm: React.FC<DealFormProps> = ({ mode }: DealFormProps) => {
    const navigateTo = useNavigate()
    const [loading, setLoading] = useState(false)
    const { id } = useParams<{ id?: string }>()
    const idNum = id ? parseInt(id) : 0
    const appContext = useAppContext()
    const [form] = Form.useForm()
    const [dealDspSeatList, setDealDspSeatList] = useState<DealDspSeatBean[]>([])
    const [entity, setEntity] = useState<DealBean>({} as DealBean)

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            apiCall(
                setLoading,
                appContext,
                () => {
                    if (mode === 'edit') {
                        return dealApi
                            .editDeal({
                                ...values,
                                dealDspSeatList: dealDspSeatList
                            }, idNum)
                    } else {
                        return dealApi
                            .createDeal({
                                ...values,
                                dealDspSeatList: dealDspSeatList
                            })
                    }
                },
                (response) => {
                    queueListRepositionOnModifiedChange({
                        appContext,
                        routeKey: CommonRoutes.DEAL,
                        previousEntity: entity,
                        responseEntity: response?.data,
                        enabled: mode === FormMode.edit
                    })

                    navigateTo(CommonRoutes.DEAL)
                })
        })
    }

    const onCancel = () => {
        navigateTo(CommonRoutes.DEAL)
    }

    const onDelete = () => {
        apiCall(setLoading, appContext, () => dealApi.deleteDeal(idNum), () => navigateTo(CommonRoutes.DEAL))
    }

    const loadData = () => {
        if (mode === 'edit') {
            apiCall(setLoading, appContext, () => dealApi.deal(idNum), (res) => {
                const seatBeans: Array<DealDspSeatBean> = res.data?.dealDspSeatList ?? []
                setDealDspSeatList(seatBeans)
                if (res?.data) {
                    setEntity(res.data)
                }
                form.setFieldsValue({ ...res.data })
            })
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    return (
        <Spin spinning={loading}>
            <AnchorsForm form={form} onFinish={handleSubmit}>
                <FormCard
                    id="deal"
                    title="Deal"
                >
                    <FormItem
                        required
                        name="name"
                        rules={[{ required: true, message: 'Please input Deal name' }]} label="Name"
                    >
                        <Input />
                    </FormItem>
                    {mode === 'edit' && (
                        <FormItem name="dealId" label="Deal ID">
                            <Input disabled />
                        </FormItem>
                    )}
                    <FormItem name="active" label="Active" valuePropName="checked" initialValue={true}>
                        <Checkbox />
                    </FormItem>
                    <FormItem required name="bidFloor" className="ant-item ant-item-first" label="Bid Floor"
                              rules={[{ required: true, message: 'Please input bid floor' }]}>
                        <InputNumber step={0.01} min={0}
                                     addonAfter="$" />
                    </FormItem>
                </FormCard>
                <FormCard
                    id="settings"
                    title="Settings"
                >
                    <FormItem name="deviceTypes" label="Device Types">
                        <DeviceTypeSelector placeholder="Select Device Type" />
                    </FormItem>
                    <FormItem name="formatTypes" label="Format Types">
                        <FormatTypeSelector multiple placeholder="Select Format Type" />
                    </FormItem>
                    <FormItem name="publishers" label="Publishers">
                        <PublisherSelector
                            placeholder="Select Publishers"
                            multiple
                        />
                    </FormItem>
                    <FormItem name="domainList" label="Domains / Bundle ID's">
                        <DomainSelector
                            placeholder="Select Domains"
                            multiple
                        />
                    </FormItem>
                    <FormItem name="auctionType" label="Auction type" initialValue={AuctionTypeEnum.PrivateAuction}>
                        <RadioGroup>
                            {Object.values(AuctionTypeEnum).map(
                                (auctionType) => (
                                    <Radio key={auctionType} value={auctionType}>
                                        {auctionType}
                                    </Radio>
                                )
                            )}
                        </RadioGroup>
                    </FormItem>
                    {/*<FormItem name="dealDspSeatList" label="DSP Seat">*/}
                    {/*    <DealDspSelector*/}
                    {/*        dealDspSeatList={dealDspSeatList || []}*/}
                    {/*        setDealDspSeatList={setDealDspSeatList}*/}
                    {/*        dealDspList={info.dealDspList}*/}
                    {/*    />*/}
                    {/*</FormItem>*/}
                </FormCard>
                <ButtonsPanel onCancel={onCancel} showDelete={mode === FormMode.edit}
                              onDelete={onDelete} />
            </AnchorsForm>
        </Spin>
    )
}

export default DealForm 
